import { csrfHeaders } from "../auth/csrf";

export type ClientIssueArea =
  | "mermaid.validation"
  | "app.unexpected"
  | "canvas.edit"
  | "canvas.render"
  | "local.recovery"
  | "local.save"
  | "bundle.open"
  | "bundle.export"
  | "revision.recovery"
  | "export.png"
  | "export.mermaid"
  | "export.svg"
  | "export.excalidraw"
  | "access.load"
  | "access.update"
  | "ai.generate"
  | "ai.preview";

export type ClientIssueKind = "invalid-source" | "unsupported" | "operation-failed" | "unexpected";

export const newIssueReference = () => {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return `MD-${[...bytes].map((value) => value.toString(16).padStart(2, "0")).join("").toUpperCase()}`;
};

const sentReferences = new Set<string>();

export const reportClientIssue = async (issue: {
  reference: string;
  area: ClientIssueArea;
  kind: ClientIssueKind;
  line?: number | null;
}) => {
  if (!import.meta.env.PROD || sentReferences.has(issue.reference)) return;
  sentReferences.add(issue.reference);
  if (sentReferences.size > 100) sentReferences.delete(sentReferences.values().next().value ?? "");
  try {
    await fetch("/api/observability/events", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json", ...csrfHeaders() },
      body: JSON.stringify(issue),
      keepalive: true,
    });
  } catch {
    // Observability must never interrupt the user's work.
  }
};
